module.exports = __webpack_public_path__ + "img/landing_box35.0ca714f2.jpg";